<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PERIOD_LOSS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.periodLoss;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(periodLoss) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PERIOD_LOSS_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(periodLoss, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updatePeriodLoss.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PERIOD_LOSS_QUERY = gql `
query ($id: ID!) {
  accountContext {
    periodLoss(id: $id) {
      id
      code
      date
      description
      periodId
      period {
        id
        name
        additionalInfo
        secondAdditionalInfo
      }
      periodLossItemsAttributes {
        id
        quantity
        unitId
        unit {
          id
          name
        }
        varietyId
        variety {
          id
          name
          title
        }
        validations
      }
      periodLossReasonId
      validations
    }
    allPeriodsWithPlantingOpenned {
      id
      name
      additionalInfo
      secondAdditionalInfo
    }
    allPeriodLossReasons {
      id
      name
    }
  }
}
`;

const UPDATE_PERIOD_LOSS_MUTATION = gql `
  mutation($input: PeriodLossUpdateInputObject!) {
    updatePeriodLoss(input: $input) {
      periodLoss {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>